// extracted by mini-css-extract-plugin
export default {"facetMenu":"Ov-z","fixed":"Pv-z","nonLayerdFacets":"Qv-z","productCount":"Rv-z","facetBack":"Sv-z","arrow":"Tv-z","facetClose":"Uv-z"};